// WARRANTY MUTATIONS
export const WARRANTY_MODULE_NAME = 'warranty'
export const WARRANTY_CLEAR_MODULE = 'WARRANTY_CLEAR_MODULE'
export const WARRANTY_UPDATE_CREATED = 'WARRANTY_UPDATE_CREATED'
export const WARRANTY_UPDATE_SINISTER_ID = 'WARRANTY_UPDATE_SINISTER_ID'
export const WARRANTY_UPDATE_SECONDARY_ID = 'WARRANTY_UPDATE_SECONDARY_ID'
export const WARRANTY_UPDATE_ADDRESS = 'WARRANTY_UPDATE_ADDRESS'
export const WARRANTY_UPDATE_ZIP_CODE = 'WARRANTY_UPDATE_ZIP_CODE'
export const WARRANTY_UPDATE_COORDINATES = 'WARRANTY_UPDATE_COORDINATES'
export const WARRANTY_UPDATE_MORE_THAN_TWO_YEARS =
  'WARRANTY_UPDATE_MORE_THAN_TWO_YEARS'
export const WARRANTY_UPDATE_PROPERTY_TYPE = 'WARRANTY_UPDATE_PROPERTY_TYPE'
export const WARRANTY_UPDATE_RESIDENT_TYPE = 'WARRANTY_UPDATE_RESIDENT_TYPE'
export const WARRANTY_UPDATE_OBSERVATIONS = 'WARRANTY_UPDATE_OBSERVATIONS'
export const WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE =
  'WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE'
export const WARRANTY_UPDATE_SINISTER_SUMMARY =
  'WARRANTY_UPDATE_SINISTER_SUMMARY'
export const WARRANTY_UPDATE_REPORT = 'WARRANTY_UPDATE_REPORT'
export const WARRANTY_UPDATE_MATERIAL_SUMMARY =
  'WARRANTY_UPDATE_MATERIAL_SUMMARY'
export const WARRANTY_UPDATE_PROPS = 'WARRANTY_UPDATE_PROPS'
export const WARRANTY_CLEAR_REPORT = 'WARRANTY_CLEAR_REPORT'
export const WARRANTY_ADD_FORMS = 'WARRANTY_ADD_FORMS'
export const WARRANTY_ADD_REPORTS = 'WARRANTY_ADD_REPORTS'
export const WARRANTY_CLEAR_FORMS = 'WARRANTY_CLEAR_FORMS'
export const WARRANTY_UPDATE_REPORTS = 'WARRANTY_UPDATE_REPORTS'
export const WARRANTY_UPDATE_DAMAGED_ITEM = 'WARRANTY_UPDATE_DAMAGED_ITEM'
export const WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS =
  'WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS'
export const WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS =
  'WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS'
export const WARRANTY_UPDATE_MURS_TOTAL_COUNT =
  'WARRANTY_UPDATE_MURS_TOTAL_COUNT'
export const WARRANTY_UPDATE_MURS_COUNT = 'WARRANTY_UPDATE_MURS_COUNT'
export const WARRANTY_UPDATE_REPORTS_MURS = 'WARRANTY_UPDATE_UPDATE_REPORT_MURS'
export const WARRANTY_UPDATE_REPORTS_PROPERTIES =
  'WARRANTY_UPDATE_REPORTS_PROPERTIES'
export const WARRANTY_UPDATE_REPORTS_BY_CATEGORY =
  'WARRANTY_UPDATE_REPORTS_BY_CATEGORY'
export const WARRANTY_CLEAR_REPORT_BY_CATEGORY =
  'WARRANTY_CLEAR_REPORT_BY_CATEGORY'
export const WARRANTY_UPDATE_ID = 'WARRANTY_UPDATE_ID'
export const WARRANTY_UPDATE_DAMAGED_PART_KEY =
  'WARRANTY_UPDATE_DAMAGED_PART_KEY'
export const WARRANTY_UPDATE_DAMAGED_ITEM_KEY =
  'WARRANTY_UPDATE_DAMAGED_ITEM_KEY'
export const WARRANTY_UPDATE_LAST_SELECTED_KEY =
  'WARRANTY_UPDATE_LAST_SELECTED_KEY'
export const WARRANTY_UPDATE_LAST_SELECTED_VALUE =
  'WARRANTY_UPDATE_LAST_SELECTED_VALUE'
export const WARRANTY_UPDATE_ID_CATEGORY_SUBTYPE =
  'WARRANTY_UPDATE_ID_CATEGORY_SUBTYPE'
export const WARRANTY_CLEAR_REPORT_MURS = 'WARRANTY_CLEAR_REPORT_MURS'
export const WARRANTY_UPDATE_CATEGORIES_QTY = 'WARRANTY_UPDATE_CATEGORIES_QTY'
export const WARRANTY_UPDATE_CATEGORIES_MOBILIER =
  'WARRANTY_UPDATE_CATEGORIES_MOBILIER'
export const WARRANTY_UPDATE_LITERALS_MOBILIER =
  'WARRANTY_UPDATE_LITERALS_MOBILIER'
export const WARRANTY_CLEAR_MOBILIER_PROPERTIES =
  'WARRANTY_CLEAR_MOBILIER_PROPERTIES'
export const WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER =
  'WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER'
export const WARRANTY_UPDATE_CATEG_FINAL_LEVEL =
  'WARRANTY_UPDATE_CATEG_FINAL_LEVEL'
export const WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES =
  'WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES'
export const WARRANTY_UPDATE_PRODUCT_ID_UPTEC_FEATURE =
  'WARRANTY_UPDATE_PRODUCT_ID_UPTEC_FEATURE'
export const WARRANTY_UPDATE_OBJ_UPTEC = 'WARRANTY_UPDATE_OBJ_UPTEC'
export const WARRANTY_UPDATE_RESULT_DECLARATION =
  'WARRANTY_UPDATE_RESULT_DECLARATION'
export const WARRANTY_UPDATE_DAMAGE_TYPE_LITERAL =
  'WARRANTY_UPDATE_DAMAGE_TYPE_LITERAL'
export const WARRANTY_UPDATE_REPORTS_SURFACE = 'WARRANTY_UPDATE_REPORTS_SURFACE'
export const WARANTY_UPDATE_HAS_UPPTEC_DAMAGE =
  'WARANTY_UPDATE_HAS_UPPTEC_DAMAGE'
export const WARRANTY_MUT_EXEC_CODE = 'WARRANTY_MUT_EXEC_CODE'
export const WARRANTY_UPDATE_IS_MULTIDAMAGE = 'WARRANTY_UPDATE_IS_MULTIDAMAGE'
export const WARRANTY_UPDATE_MULTIDAMAGE = 'WARRANTY_UPDATE_MULTIDAMAGE'

// WARRANTY ACTIONS
export const WARRANTY_GET_SINISTER_SUMMARY = 'WARRANTY_GET_SINISTER_SUMMARY'
export const WARRANTY_DELETE_DAMAGE = 'WARRANTY_DELETE_DAMAGE'
export const WARRANTY_GET_REPORT = 'WARRANTY_GET_REPORT'
export const WARRANTY_GET_MATERIAL_SUMMARY = 'WARRANTY_GET_MATERIAL_SUMMARY'
export const WARRANTY_GET_SINISTER = 'WARRANTY_GET_SINISTER'
export const WARRANTY_GET_SINISTER_WOLOADER = 'WARRANTY_GET_SINISTER_WOLOADER'
export const WARRANTY_GET_FORMS = 'WARRANTY_GET_FORMS'
export const WARRANTY_GET_FINAL_LEVEL = 'WARRANTY_GET_FINAL_LEVEL'
export const WARRANTY_GET_RESULT_DECLARATION = 'WARRANTY_GET_RESULT_DECLARATION'
export const WARRANTY_UPDATE_FORMID = 'WARRANTY_UPDATE_FORMID'
export const WARRANTY_UPDATE_SINID = 'WARRANTY_UPDATE_SINID'

// MAIN
export const UPDATE_LOADER = 'UPDATE_LOADER'
export const UPDATE_VIEW = 'UPDATE_VIEW'
export const UPDATE_CART_IS_ACTIVE = 'UPDATE_CART_IS_ACTIVE'

export const FNOL_MODULE_NAME = 'fnol'
export const FNOL_UPDATE_ID_FLUX = 'FNOL_UPDATE_ID_FLUX'
export const FNOL_UPDATE_EXECUTION_CODE_MUT = 'FNOL_UPDATE_EXECUTION_CODE_MUT'
export const FNOL_DAMAGES_CONFIRMED_MUT = 'FNOL_DAMAGES_CONFIRMED_MUT'
export const FNOL_MAVALUE_REPORT_COMPONENT_MUT =
  'FNOL_MAVALUE_REPORT_COMPONENT_MUT'
